import JWT from "@/utils/jwt"
import router from "@/router";
import { login, mobilefone, info, register, refreshToken, forgotPassword, resetPassword } from './api'
import { SET_ACCESS_TOKEN, SET_AUTH, PURGE_AUTH, SET_ERROR, SET_LOADING, SET_STATUS, CLEAR_DATA } from "./constants";

const authRegister = async ({ commit }, user) => {
  commit(SET_LOADING, true);
  await register(user)
    .then((response) => {
      commit(SET_LOADING, false);

      if (response && response.data && response.data.access_token) {
        commit(SET_ACCESS_TOKEN, response.data);

        if (user && user.nextUrl && user.nextUrl.length > 0) {
          if (user.nextUrl.startsWith('/')) {
            router.push(user.nextUrl).catch(() => {});
          } else {
            window.location.href = user.nextUrl
          }
        } else {
          router.push({ name: 'home' }).catch(() => {})
        }
      } else {
        const errors = response ? response.data : null

        for (var item in errors) {
          commit(SET_ERROR, errors[item].shift())
        }
      }
    })
    .catch(err => {
      commit(SET_LOADING, false);
      if (err && err.response && err.response.data) {
        if (err.response.data.error) {
          commit(SET_ERROR, err.response.data.error)
        } else if (err.response.data.message) {
          commit(SET_ERROR, err.response.data.message)
        } else {
          commit(SET_ERROR, err.response.data)
        }
      } else {
        commit(SET_ERROR, (err && err.message) || err || 'Có lỗi xảy ra')
      }
    });
};

const authLogin = async ({ commit }, { email, password, nextUrl }) => {
  commit(SET_LOADING, true);
  await login(email, password)
    .then((response) => {
      commit(SET_LOADING, false);
      commit(SET_ACCESS_TOKEN, response.data);

      if (nextUrl && nextUrl.length > 0) {
        if (nextUrl.startsWith('/')) {
          router.push(nextUrl).catch(() => {});
        } else {
          window.location.href = nextUrl
        }
      } else {
        router.push({ name: 'home' }).catch(() => {})
      }
    })
    .catch(err => {
      commit(SET_LOADING, false);

      if (err && err.response && err.response.data) {
        if (err.response.data.error) {
          commit(SET_ERROR, err.response.data.error)
        } else if (err.response.data.message) {
          commit(SET_ERROR, err.response.data.message)
        } else {
          commit(SET_ERROR, err.response.data)
        }
      } else {
        commit(SET_ERROR, (err && err.message) || err || 'Có lỗi xảy ra')
      }
    });
};

const authMobiedu = async ({ commit }, { phone, password, nextUrl }) => {
  commit(SET_LOADING, true);
  await mobilefone(phone, password)
    .then((response) => {
      commit(SET_LOADING, false);
      commit(SET_ACCESS_TOKEN, response.data);

      if (nextUrl && nextUrl.length > 0) {
        if (nextUrl.startsWith('/')) {
          router.push(nextUrl).catch(() => {});
        } else {
          window.location.href = nextUrl
        }
      } else {
        router.push({ name: 'home' }).catch(() => {})
      }
    })
    .catch(err => {
      commit(SET_LOADING, false);

      if (err && err.response && err.response.data) {
        if (err.response.data.error) {
          commit(SET_ERROR, err.response.data.error)
        } else if (err.response.data.message) {
          commit(SET_ERROR, err.response.data.message)
        } else {
          commit(SET_ERROR, err.response.data)
        }
      } else {
        commit(SET_ERROR, (err && err.message) || err || 'Có lỗi xảy ra')
      }
    });
};

const authToken = async ({ commit }) => {
  let refreshToken = JWT.getRefreshToken()
  if (refreshToken) {
    await refreshToken({
      token: refreshToken
    })
      .then((res) => {
        commit(SET_ACCESS_TOKEN, res.data)
      })
      .catch((err) => {
        if (err && err.response && err.response.data) {
          commit(SET_ERROR, err.response.data)
        } else {
          commit(SET_ERROR, (err && err.message) || err)
        }
      })
  }
}

const authLogout = async ({ commit }) => {
  commit(PURGE_AUTH);
  JWT.destroyToken();
  router.push("/");
};

const authForgotPassword = async ({ commit }, { email }) => {
  commit(SET_LOADING, true);
  forgotPassword(email)
    .then(() => {
      commit(SET_LOADING, false);
      const status = { page: 'ForgotPassword', isDone: true }
      commit(SET_STATUS, status);
    })
    .catch((err) => {
      commit(SET_LOADING, false);
      if (err && err.response && err.response.data) {
        commit(SET_ERROR, err.response.data.errors || err.response.data.message || err.response.data);
      } else {
        commit(SET_ERROR, (err && err.message) || err);
      }
    });
};

const authResetPassword = async ({ commit }, { email, password, verify_code }) => {
  commit(SET_LOADING, true);
  await resetPassword(email, password, verify_code)
    .then(() => {
      commit(SET_LOADING, false);
      const status = { page: 'ResetPassword', isDone: true }
      commit(SET_STATUS, status);
    })
    .catch((err) => {
      commit(SET_LOADING, false);
      if (err && err.response && err.response.data) {
        commit(SET_ERROR, err.response.data.errors || err.response.data.message || err.response.data);
      } else {
        commit(SET_ERROR, (err && err.message) || err);
      }
    });
};

const authInfo = async ({ commit }) => {
  if (JWT.getAccessToken()) {
    await info()
      .then((res) => {
        commit(SET_AUTH, res.data)
      })
      .catch((err) => {
        if (err && err.response && err.response.data) {
          commit(SET_ERROR, err.response.data)
        } else {
          commit(SET_ERROR, (err && err.message) || err)
        }
      })
  } else {
    if (JWT.getRefreshToken()) {
      await refreshToken({
        token: `${JWT.getRefreshToken()}`
      })
        .then((resToken) => {
          commit(SET_LOADING, false)
          commit(SET_ACCESS_TOKEN, resToken.data)
        })
        .catch(err => {
          commit(PURGE_AUTH)
          commit(SET_LOADING, false)
          if (err && err.response && err.response.data) {
            commit(SET_ERROR, err.response.data)
          } else {
            commit(SET_ERROR, (err && err.message) || err)
          }
        })
    } else {
      commit(PURGE_AUTH)
    }
  }
};

const setLoading = ({ commit }, value) => {
  commit(SET_LOADING, value);
};

const setStatus = ({ commit }, value) => {
  commit(SET_STATUS, value);
};

const clearData = ({ commit }) => {
  commit(CLEAR_DATA);
};

export default {
  authToken,
  authLogin,
  authMobiedu,
  authLogout,
  authRegister,
  authForgotPassword,
  authResetPassword,
  authInfo,
  setLoading,
  setStatus,
  clearData
};
